"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnlyHeaderLayoutPage = void 0;
var _components = require("../../components");
var _internal = require("./internal");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Represents a layout component with only a header.
 *
 * This component wraps the provided content within a P component,
 * with additional features tailored for a header-only layout.
 *
 * @param props - Props for the {@link OnlyHeaderLayoutPageProps} component.
 * @returns A JSX element representing the OnlyHeaderLayout.
 *
 * @remarks
 * This component is designed to provide a layout with only a header, suitable for certain types of pages.
 *
 * @example
 * ```tsx
 * <OnlyHeaderLayout>
 *   <PageContent />
 * </OnlyHeaderLayout>
 * ```
 */
const OnlyHeaderLayoutPage = ({
  page,
  layout,
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Page, {
  ...page,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_internal.OnlyHeaderLayout, {
    ...layout,
    children: children
  })
});
exports.OnlyHeaderLayoutPage = OnlyHeaderLayoutPage;
